/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Dale Francis (dalefrancis88) */

// isTruthy : a -> Boolean
function isTruthy(x) {
  return !!x
}

module.exports = isTruthy
